<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import Select from '$components/Form/Select.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Construction de hangar`,
        `Charpente métallique`,
        `Bâtiment métallique préfabriqué`,
        `Structure pour station-service`,
        `Montage d'usine`,
        `Travaux de chaudronnerie / soudure`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const structureUsageOptions = [
        `Industriel`,
        `Agricole`,
        `Commercial`,
        `Stockage / logistique`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const surfaceAreaOptions = [
        `Moins de 100 m²`,
        `Entre 100 et 300 m²`,
        `Entre 300 et 600 m²`,
        `Plus de 600 m²`,
        `Je ne sais pas encore`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const serviceTypeOptions = [
        `Fabrication uniquement`,
        `Fabrication + montage`,
        `Fabrication + montage + livraison sur site`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const additionalServicesOptions = [
        `Sablage / peinture industrielle`,
        `Portes métalliques sur mesure`,
        `Maintenance ou SAV`,
        `Transport / logistique`,
        `Aucune pour le moment`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.constructionMetallique.projectType}
        class=""
        let:field
        let:id
        label={`Quel est le type de projet concerné ?`}
        helpLabel="Maximum 2"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={2}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={projectTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.constructionMetallique.structureUsage}
        class=""
        let:field
        let:id
        label={`Quel usage est prévu pour la structure métallique ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={structureUsageOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.constructionMetallique.surfaceArea}
        class=""
        let:field
        let:id
        label={`Quelle est la surface estimée de la structure ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={surfaceAreaOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.constructionMetallique.serviceType}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous uniquement la fabrication, ou aussi l'installation ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-1 gap-x-6 gap-y-1"
            choices={serviceTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.constructionMetallique.additionalServices}
        class=""
        let:field
        let:id
        label={`Avez-vous besoin d'une prestation complémentaire ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={additionalServicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
